import { Component, Input, OnInit } from "@angular/core";
import { ReferenceCodeService } from "@app/admin/reference-code/reference-code.service";
import { KycVerificationResponseComposite } from "@app/applications/application-details/applicant/applicantKycProofs/applicant-kyc-proof.model";
import { NameValueDto } from "@app/loan-od-accounts/name-value-dto";

@Component({
  selector: "business-kyc-idproof-verification",
  templateUrl: "business-kyc-idproof-verification-evidence.template.html",
  styleUrls: [
    "../../../application-details.styles.scss",
    "../xdata-service.style.scss",
  ],
})
export class BusinessKycIdProofVerificationComponent implements OnInit {
  @Input()
  documentVerificationResponse: KycVerificationResponseComposite;

  @Input()
  // this is to determine from which component this common component is called from, right now possible values are "evidence" and "verification"
  // "evidence" will be from kycProof which will show server provider data used for verification, "verification" is from kycVerificationComponent which will show both internal and service provider data for user to verify.
  caller: any;
  stateList: NameValueDto[];
  districtList: NameValueDto[];
  cityList: NameValueDto[];
  industryTypes: NameValueDto;
  constitutions: NameValueDto;

  constructor(private referenceCodeService:ReferenceCodeService) {}

  ngOnInit() {
    this.referenceCodeService.getRefCodesForClassifier('State').subscribe((response: any) => {
      this.stateList = response;
    });
    this.referenceCodeService.getRefCodesForClassifier('District').subscribe((response: any) => {
      this.districtList = response;
    });
    this.referenceCodeService.getRefCodesForClassifier('City').subscribe((response: any) => {
      this.cityList = response;
    });
    this.referenceCodeService.getShortRefCodes('industry_type').subscribe((response: any) => {
      this.industryTypes = response.industry_type;
    });
    this.referenceCodeService.getShortRefCodes('constitution').subscribe((response: any) => {
      this.constitutions = response.constitution;
    });
  }

}